import { Button } from '@chegg-ui/button'
import { spacing } from '@chegg-ui/theme'
import styled from 'styled-components'
import { BlurredCardOwnProps } from './types'

export const BlurredCardHeader = styled.div<BlurredCardOwnProps>`
  display: flex;
  flex-direction: column;
  height: 120px;
  background-color: ${({ phone, theme }) => (phone ? theme.colors.white : '')};
  margin: 0 auto;
  align-content: center;
  box-shadow: inset 0 -2px 0 0 ${({ theme }) => theme.colors.white},
    0 0 ${spacing.px4} rgba(34, 34, 34, 0.24);
  border-radius: 0;
  border: solid 1px ${({ theme }) => theme.colors.greyLight};
  margin-top: ${spacing.px4};
`

export const BlurContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 0;
  align-content: center;
  margin-top: -75px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0 30px 30px ${({ theme }) => theme.colors.white};
`

export const Heading = styled.span`
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 700;
  font-size: ${({ theme }) => theme.font.text.size.lg};
  text-align: center;
  top: -50px;
  padding-left: 26px;
  padding-right: 26px;
  max-width: 280px;
`

export const UpgradeButton = styled(Button).attrs({ size: 'medium' })`
  margin: 0 auto;
  margin-top: ${({ theme }) => theme.spacing.md3};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

export const BlurredCardContainer = styled.div``



// WEBPACK FOOTER //
// ./src/layouts/shared/BlurredCard/styles.tsx